<script lang="ts">
    import IconCheck from '../Icons/IconCheck.svelte';
    import IconEmpty from '../Icons/IconEmpty.svelte';

    export let item: {
        id: string;
        label: string;
        alreadyUsed: boolean;
        exampleValues: string[];
    } = {
        id: '',
        label: '',
        alreadyUsed: false,
        exampleValues: ['mała', 'wielka'],
    };
</script>

<div class="customItem">
    <div class="customItem_title"></div>
    <div class="customItem_prop">
        {#if item.alreadyUsed}
            <IconCheck scale={0.5} />
        {:else}
            <IconEmpty scale={0.5} />
        {/if}
    </div>
    <div class="customItem_label">{item.label}</div>
    {#if typeof item.exampleValues === 'object' && item.id !== ''}
        <div class="customItem_examples">
            (
            {#each item.exampleValues as exampleValue}
                <div class="customItem_example">{exampleValue}</div>
                {#if item.exampleValues.length > 1 && exampleValue !== item.exampleValues[item.exampleValues.length - 1]},
                {/if}
            {/each}
            )
        </div>
    {/if}
</div>

<style>
    .customItem {
        display: flex;
        flex-direction: row;
        /*font-size: 12px;*/
        column-gap: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        align-items: center;
        font-family: 'roboto' !important;
        font-size: 15px;
    }
    .customItem_examples {
        display: flex;
        flex-direction: row;
        opacity: 0.7;
        font-size: 12px;
    }
</style>
